<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div class="row mb-2">
              <div class="col-12 text-right">
                <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
              </div>
            </div>
            <div class="mt-3" v-if="bpsblueprint!==null">
              <div class="row">
                <div class="col-8">
                  <h2>Bundle Product Schedules For {{BundleName}}</h2>
                </div>
                <div class="col-4 text-right">
                  <button class="btn btn-secondary btn-short smallheight nopadding" @click="openAddProductBundleSchedule">Add</button>
                </div>
              </div>
              <div v-show="bpsblueprint.length>0">
                <div class="row mt-4">
                  <div class="col-6">
                    <b>Product</b>
                  </div>
                  <div class="col-2">
                    <b>Becomes Available</b>
                  </div>
                  <div class="col-2">
                    <b>Becomes Unavailable</b>
                  </div>
                  <div class="col-2">
                    <b>Remove</b>
                  </div>
                </div>
                <div v-for="bps in bpsblueprint" class="row mt-1">
                  <div class="col-6">
                    {{bps.ProductName}}
                  </div>
                  <div class="col-2">
                    {{bps.ScheduleStart}}
                  </div>
                  <div class="col-2">
                    {{bps.ScheduleEnd}}
                  </div>
                  <div class="col-2">
                    <button class="btn-transparent" @click="doRemoveSchedule(bps.BundleProductID,bps.BundleScheduleID)"><font-awesome-icon icon="times"></font-awesome-icon></button>
                  </div>
                </div>

              </div>
              <div class="row mt-2" v-show="bpsblueprint.length===0">
                <div class="col-12">
                  There are no bundle product schedules
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="aeBundleProductSchedule" size="lg" title="Add Bundle Product Schedule" @ok="doAddBundleProductSchedule">
      <div class="row">
         <div class="col-12">
            <label class="text-dark">Product</label><br />
            <select class="fullWidth" v-model="thisBundleProduct">
               <option v-for="bp in BundleProducts" v-bind:value="bp.BundleProductID">{{bp.ProductName}}</option>
            </select>
         </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <b>Start Date</b>
          <v-date-picker v-model="thisStartDate"></v-date-picker>
        </div>
        <div class="col-6">
          <b>End Date</b>
          <v-date-picker v-model="thisEndDate"></v-date-picker>
        </div>
      </div>
    </b-modal>
    <acfooter></acfooter>
  </div>
</template>

<script>
  import "core-js/stable";
  import "regenerator-runtime/runtime";
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
 

  export default {
    name: 'BundleSchedules',
    components: {acheader,acfooter,poolsidebar},
    data() {
      return {
        bpsblueprint:null,
        BundleName:null,
        BundleProducts:[],
        thisBundleProduct:null,
        thisStartDate:null,
        thisEndDate:null
      }
    },
    methods: {
      doAddBundleProductSchedule() {
        if (this.thisBundleProduct===null) {
          this.popDialog(1, "Bundle Product is required");
          return;
        }
        if (this.thisStartDate===null || this.thisEndDate===null) {
          this.popDialog(1, "Start and End Date are Required");
          return;
        }

        var d1=new Date(this.thisStartDate);
        var d2=new Date(this.thisEndDate);

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "AddBundleProductSchedule",
            Fields: {
              LicensePoolID: this.$route.params.pid,
              BundleID: this.$route.params.bid,
              BundleProductID: this.thisBundleProduct,
              StartDate: d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+(d1.getDate())+" 00:00:00",
              EndDate: d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+(d2.getDate())+" 00:00:00"
            }
          }
        ]).then(r=>{
          this.popDialog(0,"The Schedule Has Been Added");
          this.render();
        })
      },
      doRemoveSchedule(bpid,schdID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this bundle schedule?', {
          title: 'Confirm Remove',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {

            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "RemoveBundleProductSchedule",
                Fields: {
                  LicensePoolID: this.$route.params.pid,
                  BundleID: this.$route.params.bid,
                  BundleProductID: bpid,
                  BundleScheduleID: schdID
                }
              }
            ]).then(r=> {
              this.popDialog(0,"The Schedule Has Been Removed");
              this.render();
            });
          }
        });
      },
      goBack() {
        this.$router.back();
      },
      openAddProductBundleSchedule() {
        this.$refs["aeBundleProductSchedule"].show();
      },
      render() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetBundleProducts",
            Fields: {
              LicensePoolID: this.$route.params.pid
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetBundles",
            Fields: {
              LicensePoolID: this.$route.params.pid
            }
          }
        ]).then(response=> {

          var cr=JSON.parse(response.CommandResult);
          var bps=JSON.parse(cr.returnObjects[0].returnObject);
          var bd=JSON.parse(cr.returnObjects[1].returnObject);
   
          this.BundleProducts=bps.filter(p=>p.BundleID===this.$route.params.bid);
          this.BundleProducts.unshift({
            BundleProductID: null,
            ProductName: "--- Select ---"
          });

          try {
            var thisbd=bd.filter(p=>p.BundleID===this.$route.params.bid)[0];
            this.BundleName=thisbd.BundleName;
          }
          catch(e) {}

          var cmds=[];
          var blueprint=[];

          for(var bp of bps) {
            if (bp.BundleID===this.$route.params.bid) {
              cmds.push({
                Operation: "LicensePool",
                Function: "GetBundleProductSchedules",
                Fields: {
                  LicensePoolID: this.$route.params.pid,
                  BundleID: this.$route.params.bid,
                  BundleProductID: bp.BundleProductID
                }
              });
              blueprint.push({
                ProductName: bp.ProductName,
                BundleProductID: bp.BundleProductID,
                HasSchedule:false
              })
            }
          }
;

          this.apiCommand(cmds).then(r=>{
            var cr=JSON.parse(r.CommandResult);
            for(var x=0; x<cmds.length; x++) {
              var bpsitems = JSON.parse(cr.returnObjects[x].returnObject);
              for(var bpsitem of bpsitems) {
                var blueprintitem = blueprint.filter(p=>p.BundleProductID===bpsitem.BundleProductID);
                if (blueprintitem.length>0) {
                  blueprintitem[0].ScheduleStart=this.buildDateTime(bpsitem.ScheduleStart,true);
                  blueprintitem[0].ScheduleEnd=this.buildDateTime(bpsitem.ScheduleEnd,true);
                  blueprintitem[0].BundleScheduleID=bpsitem.BundleScheduleID;
                  blueprintitem[0].HasSchedule=true;
                }
              }
            }

            this.bpsblueprint=blueprint.filter(p=>p.HasSchedule===true);
          })
      

        });
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.pid);
        this.render();   
   
      });
    }
  }
</script>
